import { Scene as g, WebGLRenderer as w, sRGBEncoding as y, PerspectiveCamera as M, Mesh as x, MeshStandardMaterial as A, Group as v, BufferGeometry as b, BufferAttribute as E } from "three";
import { CSS3DRenderer as R } from "three/addons/renderers/CSS3DRenderer.js";
import { C as I } from "./controller-C8QRdV1_.js";
import { U as S } from "./ui-DWEIEpuJ.js";
const F = { BufferGeometry: b, BufferAttribute: E };
class U {
  constructor({
    container: o,
    uiLoading: e = "yes",
    uiScanning: t = "yes",
    uiError: a = "yes",
    filterMinCF: s = null,
    filterBeta: c = null,
    userDeviceId: i = null,
    environmentDeviceId: d = null,
    disableFaceMirror: m = !1
  }) {
    this.container = o, this.ui = new S({ uiLoading: e, uiScanning: t, uiError: a }), this.controller = new I({
      filterMinCF: s,
      filterBeta: c
    }), this.disableFaceMirror = m, this.scene = new g(), this.cssScene = new g(), this.renderer = new w({ antialias: !0, alpha: !0 }), this.cssRenderer = new R({ antialias: !0 }), this.renderer.outputEncoding = y, this.renderer.setPixelRatio(window.devicePixelRatio), this.camera = new M(), this.userDeviceId = i, this.environmentDeviceId = d, this.anchors = [], this.faceMeshes = [], this.latestEstimate = null, this.container.appendChild(this.renderer.domElement), this.container.appendChild(this.cssRenderer.domElement), this.shouldFaceUser = !0, window.addEventListener("resize", this._resize.bind(this));
  }
  async start() {
    this.ui.showLoading(), await this._startVideo(), await this._startAR(), this.ui.hideLoading();
  }
  stop() {
    this.video.srcObject.getTracks().forEach(function(e) {
      e.stop();
    }), this.video.remove(), this.controller.stopProcessVideo();
  }
  switchCamera() {
    this.shouldFaceUser = !this.shouldFaceUser, this.stop(), this.start();
  }
  addFaceMesh() {
    const o = this.controller.createThreeFaceGeometry(F), e = new x(o, new A({ color: 16777215 }));
    return e.visible = !1, e.matrixAutoUpdate = !1, this.faceMeshes.push(e), e;
  }
  addAnchor(o) {
    const e = new v();
    e.matrixAutoUpdate = !1;
    const t = { group: e, landmarkIndex: o, css: !1 };
    return this.anchors.push(t), this.scene.add(e), t;
  }
  addInterpolatedAnchor(o, e = null) {
    const t = new v();
    t.matrixAutoUpdate = !1;
    const a = { group: t, landmarkIndex: null, landmarkWeights: o, metricOffset: e, css: !1 };
    return this.anchors.push(a), this.scene.add(t), a;
  }
  // computeFn receives live metricLandmarks (468×3 array) plus the full
  // estimateResult ({metricLandmarks, faceMatrix, faceScale, blendshapes})
  // and must return [x, y, z] in canonical face metric space.
  // Called every frame, so keep it cheap.
  addDynamicAnchor(o) {
    const e = new v();
    e.matrixAutoUpdate = !1;
    const t = { group: e, computeFn: o, landmarkIndex: null, css: !1 };
    return this.anchors.push(t), this.scene.add(e), t;
  }
  addCSSAnchor(o) {
    const e = new v();
    e.matrixAutoUpdate = !1;
    const t = { group: e, landmarkIndex: o, css: !0 };
    return this.anchors.push(t), this.cssScene.add(e), t;
  }
  getLatestEstimate() {
    return this.latestEstimate;
  }
  _startVideo() {
    return new Promise((o, e) => {
      if (this.video = document.createElement("video"), this.video.setAttribute("autoplay", ""), this.video.setAttribute("muted", ""), this.video.setAttribute("playsinline", ""), this.video.style.position = "absolute", this.video.style.top = "0px", this.video.style.left = "0px", this.video.style.zIndex = "-2", this.container.appendChild(this.video), !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.ui.showCompatibility(), e();
        return;
      }
      const t = {
        audio: !1,
        video: {}
      };
      this.shouldFaceUser ? this.userDeviceId ? t.video.deviceId = { exact: this.userDeviceId } : t.video.facingMode = "user" : this.environmentDeviceId ? t.video.deviceId = { exact: this.environmentDeviceId } : t.video.facingMode = "environment", navigator.mediaDevices.getUserMedia(t).then((a) => {
        this.video.addEventListener("loadedmetadata", () => {
          this.video.setAttribute("width", this.video.videoWidth), this.video.setAttribute("height", this.video.videoHeight), o();
        }), this.video.srcObject = a;
      }).catch((a) => {
        console.log("getUserMedia error", a), e();
      });
    });
  }
  _startAR() {
    return new Promise(async (o, e) => {
      const t = this.video;
      this.container, this.controller.onUpdate = ({ hasFace: s, estimateResult: c }) => {
        for (let i = 0; i < this.anchors.length; i++)
          this.anchors[i].css ? this.anchors[i].group.children.forEach((d) => {
            d.element.style.visibility = s ? "visible" : "hidden";
          }) : this.anchors[i].group.visible = s;
        for (let i = 0; i < this.faceMeshes.length; i++)
          this.faceMeshes[i].visible = s;
        if (s) {
          const { metricLandmarks: i, faceMatrix: d, faceScale: m, blendshapes: u } = c;
          this.latestEstimate = c;
          for (let n = 0; n < this.anchors.length; n++) {
            const h = this.anchors[n];
            let r;
            if (h.computeFn)
              r = this.controller.getMetricLandmarkMatrix(h.computeFn(i, c));
            else if (h.landmarkWeights) {
              const l = [0, 0, 0];
              for (const [f, p] of h.landmarkWeights)
                l[0] += i[f][0] * p, l[1] += i[f][1] * p, l[2] += i[f][2] * p;
              h.metricOffset && (l[0] += h.metricOffset[0], l[1] += h.metricOffset[1], l[2] += h.metricOffset[2]), r = this.controller.getMetricLandmarkMatrix(l);
            } else
              r = this.controller.getLandmarkMatrix(h.landmarkIndex);
            if (h.css) {
              const f = [
                1e-3 * r[0],
                1e-3 * r[1],
                r[2],
                r[3],
                1e-3 * r[4],
                1e-3 * r[5],
                r[6],
                r[7],
                1e-3 * r[8],
                1e-3 * r[9],
                r[10],
                r[11],
                1e-3 * r[12],
                1e-3 * r[13],
                r[14],
                r[15]
              ];
              h.group.matrix.set(...f);
            } else
              h.group.matrix.set(...r);
          }
          for (let n = 0; n < this.faceMeshes.length; n++)
            this.faceMeshes[n].matrix.set(...d);
        } else
          this.latestEstimate = null;
      }, this._resize();
      const a = this.shouldFaceUser && !this.disableFaceMirror;
      await this.controller.setup(a), await this.controller.dummyRun(t), this._resize(), this.controller.processVideo(t), o();
    });
  }
  _resize() {
    const { renderer: o, cssRenderer: e, camera: t, container: a, video: s } = this;
    if (!s) return;
    {
      this.video.setAttribute("width", this.video.videoWidth), this.video.setAttribute("height", this.video.videoHeight), this.controller.onInputResized(s);
      const { fov: h, aspect: r, near: l, far: f } = this.controller.getCameraParams();
      this.camera.fov = h, this.camera.aspect = r, this.camera.near = l, this.camera.far = f, this.camera.updateProjectionMatrix(), this.renderer.setSize(this.video.videoWidth, this.video.videoHeight), this.cssRenderer.setSize(this.video.videoWidth, this.video.videoHeight);
    }
    let c, i;
    const d = s.videoWidth / s.videoHeight, m = a.clientWidth / a.clientHeight;
    d > m ? (i = a.clientHeight, c = i * d) : (c = a.clientWidth, i = c / d), s.style.top = -(i - a.clientHeight) / 2 + "px", s.style.left = -(c - a.clientWidth) / 2 + "px", s.style.width = c + "px", s.style.height = i + "px", this.shouldFaceUser && !this.disableFaceMirror ? s.style.transform = "scaleX(-1)" : s.style.transform = "scaleX(1)";
    const u = o.domElement, n = e.domElement;
    u.style.position = "absolute", u.style.top = s.style.top, u.style.left = s.style.left, u.style.width = s.style.width, u.style.height = s.style.height, n.style.position = "absolute", n.style.top = s.style.top, n.style.left = s.style.left, n.style.transformOrigin = "top left", n.style.transform = "scale(" + c / parseFloat(n.style.width) + "," + i / parseFloat(n.style.height) + ")";
  }
}
window.MINDAR || (window.MINDAR = {});
window.MINDAR.FACE || (window.MINDAR.FACE = {});
window.MINDAR.FACE.MindARThree = U;
export {
  U as MindARThree
};
